import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import FormActionButtons from '../../../../Shared/FormAction/FormActionButtons';
import LicenseStatus from './LicenseStatus';
import { Form, Schema } from 'rsuite';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import licenseStatusService from '../../../../../services/Public/Renewal/PE/licenseStatus.service';
import publicRenewalService from '../../../../../services/Public/Renewal/PE/peRenewal.service';
import entityService from '../../../../../services/Internal/Staff/entity.service';
import Swal from 'sweetalert2';
import Information from '../../../../Shared/Card/Information';
import { GetRenewalInformationContent } from '../../../../Shared/InformationContent/PeInformation';
import LoadingSpinner from '../../../../Shared/GenericComponents/LoadingSpinner';
import Issues from '../../../../Shared/Card/Issues';
import peRenewalService from '../../../../../services/Internal/Renewal/PE/peRenewal.service';
import { getRenewingintolist } from '../../../../../services/Shared/codeTable.service';
import renewalService from '../../../../../services/Internal/Renewal/renewal.service';
import FormEntityInformation from '../../../Shared/FormEntityInformation';

function LicenseStatusPage() {
    const push = useNavigate();
    const [hasLoaded, setHasLoaded] = useState(false);
    const renewalId = useSelector(x => x.currentApplicationId);
    const sectionId = 2;
    const routes = useSelector(x => x.currentRoutes);
    const [sectionData, setSectionData] = useState({});
    const [peRenewalLicenseStatuses, setPeRenewalLicenseStatuses] = useState([]);
    const [isComplete, setIsComplete] = useState(false);
    const [isUserEditable, setIsUserEditable] = useState(true);
    const [entityInfo, setEntityInfo] = useState(
        {
            lolaNum: null,
            entityName: '',
            licenseNumber: '',
            formType: "Professional Engineer Renewal",
            isIndividual: true,
            entityId: 0,
            applicationDate: "",
            currentSection: "License Status"
        }
    );
    const [formModel, setFormModel] = useState({
        gridData: [],
        renewingTo: ""
    })
    const { ObjectType } = Schema.Types;
    const model = Schema.Model({
        renewingTo: ObjectType().isRequired("This field is required.")
    });

    useEffect(() => {
        getRenewingintolist(renewalId).then(setPeRenewalLicenseStatuses);
        publicRenewalService.peGetSection(renewalId, sectionId).then((data) => {
            setSectionData(data.data);
            licenseStatusService.getLicenseStatus(renewalId).then((response) => {
                setFormModel({
                    gridData: [{ credential: response.data?.credential?.formattedLicenseNumber, credentialStatus: response.data?.credential?.status?.status }],
                    renewingTo: response.data.renewingTo ? { id: response.data.renewingTo.id, code: response.data.renewingTo.renewingTo } : null
                })
                setIsComplete(data.data.staffReviewComplete)
                renewalService.getIndividualRenewal(renewalId).then((renewalData) => {
                    setIsUserEditable(renewalData.data.status.id == 2)
                    entityService.getEntity(data.data.entityId).then((entity) => {
                        setEntityInfo(
                            {
                                ...entityInfo,
                                lolaNum: entity.data.lolaNumber,
                                entityName: entity.data.formattedName,
                                entityId: entity.data.entityId,
                                licenseNumber: renewalData.data?.credential?.formattedLicenseNumber,
                                applicationDate: renewalData.data?.dateSubmitted
                            })
                        setHasLoaded(true);
                    });
                });
            })
        })
    }, [])

    const formSubmit = (validation, event) => {
        if (!isUserEditable) {
            push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
        }
        else if (validation) {
            submitData(true);
        }
    }

    const submitData = (isForSubmit) => {
        licenseStatusService.postLicenseStatus(renewalId, formModel.renewingTo.id).then((response) => {
            if (response.data) {
                peRenewalService.peMarkSectionComplete(renewalId, sectionId, isComplete).then((data) => {
                    if (isForSubmit)
                        push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
                    else
                        Swal.fire("Saved!")
                })
            }
        })
    }

    return (
        <div className="peRenewalLicenseStatusPage">
            <Container fluid>
                <FormEntityInformation {...entityInfo} />
                <Information content={GetRenewalInformationContent("licenseStatus")} />
                <br />
                {hasLoaded ?
                    <Form model={model} fluid formValue={formModel} onChange={formModel => setFormModel(formModel)} onSubmit={formSubmit}>
                        <LicenseStatus isReadOnly={!isUserEditable} peRenewalLicenseStatuses={peRenewalLicenseStatuses} gridData={formModel.gridData} />
                        <br />
                        <Issues isUserEditable={isUserEditable} isInternal={true} type={3} sectionId={sectionData.id} setIsComplete={setIsComplete} />
                        <FormActionButtons
                            isUserEditable={isUserEditable}
                            showSectionComplete={true}
                            isComplete={isComplete}
                            isCompleteCallback={setIsComplete}
                            backToSectionLink="/internal/perenewal/sections" />
                    </Form> : <LoadingSpinner />
                }
            </Container>
        </div>
    )
}
export default LicenseStatusPage;